import { useEffect, useState } from "react";

const useResponsiveConfig = (config) => { 
  const [deviceConfig, setDeviceConfig] = useState(config.desktop);

  useEffect(() => {
    const viewports = {
      desktop : window.matchMedia("(min-width: 1024px)"),
      mobile : window.matchMedia("(max-width: 767.98px)"),
      tablet : window.matchMedia("(min-width: 768px)"),
    };


    const handleChange = () => { 
      const viewport = Object.keys(viewports).find((viewport) => viewports[viewport].matches);

      setDeviceConfig(config[viewport]);
    };

    // Triggered at the first client-side load and if query changes
    handleChange();

    Object.values(viewports).forEach((query) =>  {
      query.addEventListener("change", handleChange);
    });
    return () => {
      Object.values(viewports).forEach((query) =>  {
        query.removeEventListener("change", handleChange);
      });
    };
  }, []);

  return deviceConfig;
    
};

export default useResponsiveConfig;